__turbopack_context__.v({
  "pulse": "index-module__hle0aa__pulse",
  "pulse-dark": "index-module__hle0aa__pulse-dark",
  "skeleton": "index-module__hle0aa__skeleton",
});
